// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/common/sort.proto
/* eslint-disable */
export const protobufPackage = "squareup.connect.v2.common";
/**
 * --
 * @desc The order (e.g., chronological or alphabetical) in which results from a request are returned.
 * --
 */
export var SortOrder;
(function (SortOrder) {
    /** DESC - @desc The results are returned in descending (e.g., newest-first or Z-A) order. */
    SortOrder[SortOrder["DESC"] = 0] = "DESC";
    /** ASC - @desc The results are returned in ascending (e.g., oldest-first or A-Z) order. */
    SortOrder[SortOrder["ASC"] = 1] = "ASC";
    SortOrder[SortOrder["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SortOrder || (SortOrder = {}));
